/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class BackgroundTasksComponent extends Component {
  @service backgroundTasks;
}
